import { posthog } from '@src/lib/posthog';

/**
 * Capture a PostHog event. Basic user traits (email, plan_type, etc.) are
 * set during posthog.identify(). Partner group tracking is not yet wired —
 * pass partner info explicitly if needed until the User type includes it.
 *
 * Usage:
 *   trackEvent('asset_added', { asset_type: 'real_estate', amount_cents: 50000 })
 */
export function trackEvent(
    eventName: string,
    properties?: Record<string, unknown>,
): void {
    if (typeof window === 'undefined') return;

    posthog.capture(eventName, properties ?? {});
}
